// extracted by mini-css-extract-plugin
export default {"non-interactive-section":"XxzyrhbR9B8oadOG+6qTW37KfMKXO00qmHXDEFZDjYE="};